import { getRefreshToken, getTokenPayload } from '../cookie-auth';

export const RELOAD_BEFORE_TOKEN_EXPIRY_MS = 60 * 1000;

export const reloadApp = (): void => {
    window.location.reload();
};

export const getRefreshTokenExpiresAtMs = (): number | null => {
    const payload = getTokenPayload(getRefreshToken());
    if (!payload?.exp) {
        return null;
    }

    return payload.exp * 1000;
};

export const computeReloadDelayMs = (
    expiresAtMs: number,
    leadTimeMs: number,
    now: number,
): number => expiresAtMs - leadTimeMs - now;

export const isRefreshTokenExpiringWithin = (
    expiresAtMs: number,
    withinMs = RELOAD_BEFORE_TOKEN_EXPIRY_MS,
    now = Date.now(),
): boolean => expiresAtMs - now <= withinMs;

export const scheduleReloadBeforeRefreshTokenExpiry = (
    onReload: () => void,
    leadTimeMs = RELOAD_BEFORE_TOKEN_EXPIRY_MS,
    now = Date.now(),
    expiresAtMs: number | null = getRefreshTokenExpiresAtMs(),
): (() => void) => {
    if (!expiresAtMs) {
        return () => undefined;
    }

    const delay = computeReloadDelayMs(expiresAtMs, leadTimeMs, now);
    if (delay <= 0) {
        onReload();
        return () => undefined;
    }

    const timeoutId = window.setTimeout(onReload, delay);
    return () => window.clearTimeout(timeoutId);
};
